import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { Provider } from "@effektify/theme";
import ErrorFallback from "./components/Error.js";
import "./components/Card/CardRenderer.js";
import "./components/Card/CardWithData.js";
import "@mui/icons-material/ReportProblemRounded";
import "@mui/material/Box";
import "@mui/material/Typography";
import "react";
import Renderer from "./components/Renderer.js";
import "./components/Gradients.js";
import { HostProvider } from "./contexts/HostContext.js";
const Engine = (t0) => {
  const $ = c(6);
  const {
    content,
    loading: t1,
    onNavigate,
    components,
    helpContent
  } = t0;
  const loading = t1 === void 0 ? false : t1;
  let t2;
  if ($[0] !== components || $[1] !== content || $[2] !== helpContent || $[3] !== loading || $[4] !== onNavigate) {
    t2 = content ? /* @__PURE__ */ jsx(Provider, { children: /* @__PURE__ */ jsx(HostProvider, { onNavigate, components, helpContent, children: /* @__PURE__ */ jsx(Renderer, { content, loading }) }) }) : /* @__PURE__ */ jsx(ErrorFallback, { error: {
      name: "Renderer Config",
      message: "Content was not provided"
    } });
    $[0] = components;
    $[1] = content;
    $[2] = helpContent;
    $[3] = loading;
    $[4] = onNavigate;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export {
  Engine
};
